Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.CemSurveyResponseContent

  constructor: (json) ->
    @json = json

  getJson: ->
    @json

  getResponses: ->
    @json.response_data.items

  getGroupType: ->
    'cem_survey_response'

  getType: ->
    @json.type

  getSubType: ->
    @json.sub_type

  getPrivacy: ->
    'private'

  getContentId: ->
    @json.response_data.content_id

  isBrandContent: ->
    false

  hasUser: ->
    false

  hasProfile: ->
    false

  hasRelated: ->
    false

  getAuthorId: ->
    @getAuthorName()

  getAuthorName: ->
    @json.response_data.username

  getAuthorUsername: ->
    @getAuthorName()

  # TODO:
  getAvatar: ->
    window.image_path(@getType() + '.png')

  getChannelText: ->
    ''

  getCreatedAt: ->
    @json.created_at

  getMainText: ->
    @json.main_text

  getTitle: ->
    ''

  getLink: ->
    ''

  hasAttachments: ->
    @json.files && @json.files.length > 0

  getAttachments: (att_type) ->
    []

  hasShares: ->
    false

  getShares: ->
    []
